import * as React from 'reactn';
import { makeStyles, Typography, Divider, IconButton } from '@material-ui/core';
import { Applicazione } from '../../models/applicazione';
import blue from '@material-ui/core/colors/blue';
// import sso from '../../business/sso/actions';
import { useDispatch, useGlobal } from 'reactn';
import classNames from 'classnames';
import InfoIcon from '@material-ui/icons/Info';
import { AppType } from '../../models/applicazione';
import {useHistory } from 'react-router-dom';
import { IGlobalState } from '../../states/GlobalState';
import { Applicazioni } from '../../types/types';
import { useLogger } from '../../logger';
import actions from '../../sso/actions';

const useStyles = makeStyles({
    card: {
        // border: `1px solid ${blue[300]}`,
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: 308,
        width: 208,
        boxShadow: '4px 4px 4px 0px rgba(0,0,0,0.2), 0px 2px 4px 0px rgba(0,0,0,0.4), 0px 2px 2px -1px rgba(0,0,0,0.4)',
        backgroundColor: '#fff',
        marginTop: '1rem',
        marginBottom: '1rem',
        cursor: 'pointer'
    },
    media: {
        flex: 1,
        height: 120,        
        paddingTop: 28
    },
    content: {
        margin: '0 auto',        
    },
    text: {
        padding: 8,
        paddingTop: 24,        
        flex: '1 0 100px',
        textAlign: 'center',
        height: 120
    },
    description: {
        fontSize: '0.875em',
        color: 'rgba(0, 0, 0, 0.7)'
    },
    overlay: {
        backgroundColor: 'rgba(128, 128, 128, 0.1)',
        filter: 'grayscale(100%)'
    },
    info: {
        alignSelf: 'flex-end'
    }
});


interface Props {
    item: Applicazione;
    onClickInfo: (type: AppType) => void;
    companyName?: string;
}
export function ApplicazioneCard(props: Props) {
    const [application,setApplication] = useGlobal<IGlobalState, 'application'>('application');
    const [identity,] = useGlobal<IGlobalState, 'identity'>('identity');
    const [ip,] = useGlobal<IGlobalState, 'ip'>('ip');
    const [auth,] = useGlobal<IGlobalState, 'auth'>('auth');
    const logger = useLogger({key: 'applicazione'});
    const history = useHistory();
    const classes = useStyles();
    // const dispatch = useDispatch();
    const { item, companyName  } = props;
    
    const getImageUrl = (type: AppType) => {
        console.log('type app: ' + type);
        let name = '';
        switch(type) {
            case AppType.IFORFETTARI:
                name = 'forfe.png'; break;
            case AppType.BUDGET4U:
                name = 'budget4u.png'; break;
            case AppType.EASYSTART:
                name = 'easystart.png'; break;
            case AppType.CONVSRL:
                name = 'convsrl.png'; break;
            default:
                name = 'app_generica.png';
        }

        return `${process.env.REACT_APP_BASE_URL}/images/${name}`;
    }

    const launchApp = (e: any) => {
        if (!item.inactive) {
            // dispatch(sso.launchApplication(item));
            console.log('item nome: ' + item.Nome);
            switch (item.Type) {
                case AppType.IFORFETTARI:
                    if (identity?.ApplicationForfetari === false) {
                        logger.error('Utente non autorizzato all\'applicazione');
                        return;
                    }
                    setApplication(Applicazioni.iForfettari);
                    history.push('/iforf');
                    
                    break;
            
                case AppType.CONVSRL:
                    if (identity?.ApplicationConvenienza === false) {
                        logger.error('Utente non autorizzato all\'applicazione');
                        return;
                    }
                    setApplication(Applicazioni.ConvSrl);
                    history.push('/convsrl');                    
                    break;
                
                case AppType.BUDGET4U:
                    if (identity?.ApplicationBudget === false) {
                        logger.error('Utente non autorizzato all\'applicazione');
                        return;
                    }
                    setApplication(Applicazioni.Budget4u);
                    history.push('/budget');                    
                    break;
                
                case AppType.EASYSTART:
                    actions.launchApplication(item, ip, auth.user!, auth.authData!, "ssosix");
                    break;
                
                default:
                    break;
            }
        }
    }

    return (
        <div 
            className={classNames(classes.card, item.inactive ? classes.overlay : '')} 
            onClick={launchApp}
        >
            <img className={classes.media} src={getImageUrl(item.Type)} title='Image'/>
            <div className={classes.text}>
                <Typography variant="h6" style={{fontWeight: 700}}>{props.item.Nome}</Typography>
                <Typography variant="subtitle1" className={classes.description}>{props.item.Descrizione}</Typography>
            </div>
            <div className={classes.info}>
                <IconButton
                    onClick={(e: any) => { e.stopPropagation(); props.onClickInfo(item.Type); }}
                >
                    <InfoIcon />
                </IconButton>
            </div>
        </div>
    )
}